module.exports = __webpack_public_path__ + "img/lockdown-weihnachten.95ac7425.png";